import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import { parse } from "@fortawesome/fontawesome-svg-core";
import { validaMonto, formatMoneda, formatoMonto } from "../../util/varios";
import axios from "axios";

export const ValorIva = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtFecha = useRef();
  const txtValor = useRef(0.0);

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  useEffect(() => {}, []);

  const blanquear = () => {
    setActivate(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/actualizariva`;
		setActivate(true);
    let body = {
      operacion: 2,
      idiva: 1,
      porcentaje: txtValor.current.value.replace(/\./g, "").replace(",", "."),
      fecha: txtFecha.current.value,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "El Valor del IVA fue actualizado.",
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Campo fecha no debe estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      txtValor.current.value === "" ||
      txtValor.current.value === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe de Ingresar el Valor",
        icono: "informacion",
      });
      sigue = false;
      txtValor.current.focus();
    }

    if (sigue) {
      procesarRegistro();
    }
  };

  const cerrarModal = () => {
    props.onHide();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  /* const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    //return formatMoneda(e);
    return formatMoneda(e.replace(".", ","), ",", ".", 2);
  }; */

  const handleInputMontoChange = (event) => {
    //event.preventDefault();
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
				  event.target.value = '0,00'
			  } */
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }
      event.target.value = formatoMonto(event.target.value);
      
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const seleccionarIva = (id) => {
		setActivate(true);
    let campos = "*";
    let nomtab = "iva";
    let nomid = "idiva";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idiva > 0) {
            txtFecha.current.value = moment
              .utc(response.data.fecini)
              .format("YYYY-MM-DD");
            txtValor.current.value = formatMoneda(
              response.data.porcentaje.toString().replace(".", ","),
              ",",
              ".",
              2,
            );
          }
        }
				setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarIva(1);
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Valor del Iva</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/*  <MensajeCapcha
                    show={mostrar4}
                    onHideAcepta={validarCapcha} onHideCancela={handleCancelaCapcha} /> */}
        <Dimmer active={activate} inverted></Dimmer>
        <div style={{ height: "auto", overflow: "auto" }}>
          <div className="border-azul rounded">
            <div className="col-md-12 row px-0 mx-auto">
              <div className="input-group mb-2 input-group-sm col-sm-6">
                <label htmlFor="validationTooltipUsername">Fecha: </label>
                <input
                  type="date"
                  autocomplete="off"
                  ref={txtFecha}
                  className="form-control form-control-lg"
                  id="inputLogin"
                />
              </div>
              <div className="input-group mb-2 input-group-sm col-sm-6">
                <label className="input-group-text " id="inputGroup-sizing-sm">
                  Valor:
                </label>
                <input
                  type="text"
                  ref={txtValor}
                  defaultValue={
                    props.valoriva
                      ? formatMoneda(
                          props.valoriva.toString().replace(".", ","),
                          ",",
                          ".",
                          2,
                        )
                      : ""
                  }
                  className="form-control text-right"
                  autoComplete="off"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputRazonSoc"
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 mx-auto row">
          <button
            ref={btnAcepta}
            onClick={onChangeValidar}
            className="btn btn-success col-md-6 btn-sm rounded-pill"
          >
            <i className="fas fa-check-circle"> Aceptar</i>
          </button>
          <button
            ref={btnCancela}
            onClick={cancelar}
            className="btn btn-danger col-md-6 btn-sm rounded-pill"
          >
            <i className="fas fa-window-close"> Cancelar</i>
          </button>
        </div>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

//export default CambiarClave;
